import * as browserUtils from '@tolk-ai/browser-utils';
import * as genericUtils from '@tolk-ai/generic-utils';
import * as cryptojs from 'crypto-js';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$J =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$l = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$k = fails$l;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$k(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$j = fails$l;

var functionBindNative = !fails$j(function () {
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$e = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$e.bind(call$e) : function () {
  return call$e.apply(call$e, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind$6 = FunctionPrototype$2.bind;
var call$d = FunctionPrototype$2.call;
var uncurryThis$m = NATIVE_BIND$2 && bind$6.bind(call$d, call$d);

var functionUncurryThis = NATIVE_BIND$2 ? function (fn) {
  return fn && uncurryThis$m(fn);
} : function (fn) {
  return fn && function () {
    return call$d.apply(fn, arguments);
  };
};

var uncurryThis$l = functionUncurryThis;

var toString$8 = uncurryThis$l({}.toString);
var stringSlice$4 = uncurryThis$l(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$4(toString$8(it), 8, -1);
};

var global$I = global$J;
var uncurryThis$k = functionUncurryThis;
var fails$i = fails$l;
var classof$8 = classofRaw$1;

var Object$5 = global$I.Object;
var split$1 = uncurryThis$k(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$i(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) == 'String' ? split$1(it, '') : Object$5(it);
} : Object$5;

var global$H = global$J;

var TypeError$h = global$H.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (it == undefined) throw TypeError$h("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$5 = function (it) {
  return IndexedObject(requireObjectCoercible$5(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$j = function (argument) {
  return typeof argument == 'function';
};

var isCallable$i = isCallable$j;

var isObject$9 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$i(it);
};

var global$G = global$J;
var isCallable$h = isCallable$j;

var aFunction = function (argument) {
  return isCallable$h(argument) ? argument : undefined;
};

var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$G[namespace]) : global$G[namespace] && global$G[namespace][method];
};

var uncurryThis$j = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$j({}.isPrototypeOf);

var getBuiltIn$7 = getBuiltIn$8;

var engineUserAgent = getBuiltIn$7('navigator', 'userAgent') || '';

var global$F = global$J;
var userAgent$5 = engineUserAgent;

var process$3 = global$F.process;
var Deno = global$F.Deno;
var versions = process$3 && process$3.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$1 = engineV8Version;
var fails$h = fails$l;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$h(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$E = global$J;
var getBuiltIn$6 = getBuiltIn$8;
var isCallable$g = isCallable$j;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Object$4 = global$E.Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$g($Symbol) && isPrototypeOf$3($Symbol.prototype, Object$4(it));
};

var global$D = global$J;

var String$5 = global$D.String;

var tryToString$4 = function (argument) {
  try {
    return String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$C = global$J;
var isCallable$f = isCallable$j;
var tryToString$3 = tryToString$4;

var TypeError$g = global$C.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$6 = function (argument) {
  if (isCallable$f(argument)) return argument;
  throw TypeError$g(tryToString$3(argument) + ' is not a function');
};

var aCallable$5 = aCallable$6;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$4 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$5(func);
};

var global$B = global$J;
var call$c = functionCall;
var isCallable$e = isCallable$j;
var isObject$8 = isObject$9;

var TypeError$f = global$B.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$e(fn = input.toString) && !isObject$8(val = call$c(fn, input))) return val;
  if (isCallable$e(fn = input.valueOf) && !isObject$8(val = call$c(fn, input))) return val;
  if (pref !== 'string' && isCallable$e(fn = input.toString) && !isObject$8(val = call$c(fn, input))) return val;
  throw TypeError$f("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var isPure = false;

var global$A = global$J;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$2 = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$2(global$A, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$A[key] = value;
  } return value;
};

var global$z = global$J;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$z[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.21.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.21.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var global$y = global$J;
var requireObjectCoercible$4 = requireObjectCoercible$6;

var Object$3 = global$y.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$3 = function (argument) {
  return Object$3(requireObjectCoercible$4(argument));
};

var uncurryThis$i = functionUncurryThis;
var toObject$2 = toObject$3;

var hasOwnProperty = uncurryThis$i({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$2(it), key);
};

var uncurryThis$h = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$7 = uncurryThis$h(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$7(++id + postfix, 36);
};

var global$x = global$J;
var shared$3 = shared$4.exports;
var hasOwn$a = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$x.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$j = function (name) {
  if (!hasOwn$a(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$a(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var global$w = global$J;
var call$b = functionCall;
var isObject$7 = isObject$9;
var isSymbol$1 = isSymbol$2;
var getMethod$3 = getMethod$4;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$i = wellKnownSymbol$j;

var TypeError$e = global$w.TypeError;
var TO_PRIMITIVE = wellKnownSymbol$i('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$7(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$3(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$b(exoticToPrim, input, pref);
    if (!isObject$7(result) || isSymbol$1(result)) return result;
    throw TypeError$e("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$v = global$J;
var isObject$6 = isObject$9;

var document$3 = global$v.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$6(document$3) && isObject$6(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$8 = descriptors;
var fails$g = fails$l;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$8 && !fails$g(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$7 = descriptors;
var call$a = functionCall;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$2 = toPropertyKey$3;
var hasOwn$9 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$7 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$2(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$9(O, P)) return createPropertyDescriptor$4(!call$a(propertyIsEnumerableModule.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$6 = descriptors;
var fails$f = fails$l;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$6 && fails$f(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var global$u = global$J;
var isObject$5 = isObject$9;

var String$4 = global$u.String;
var TypeError$d = global$u.TypeError;

// `Assert: Type(argument) is Object`
var anObject$f = function (argument) {
  if (isObject$5(argument)) return argument;
  throw TypeError$d(String$4(argument) + ' is not an object');
};

var global$t = global$J;
var DESCRIPTORS$5 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$e = anObject$f;
var toPropertyKey$1 = toPropertyKey$3;

var TypeError$c = global$t.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$5 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$e(O);
  P = toPropertyKey$1(P);
  anObject$e(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$e(O);
  P = toPropertyKey$1(P);
  anObject$e(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$c('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$4 = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;

var createNonEnumerableProperty$6 = DESCRIPTORS$4 ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var redefine$8 = {exports: {}};

var uncurryThis$g = functionUncurryThis;
var isCallable$d = isCallable$j;
var store$1 = sharedStore;

var functionToString = uncurryThis$g(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$d(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$s = global$J;
var isCallable$c = isCallable$j;
var inspectSource$3 = inspectSource$4;

var WeakMap$1 = global$s.WeakMap;

var nativeWeakMap = isCallable$c(WeakMap$1) && /native code/.test(inspectSource$3(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$r = global$J;
var uncurryThis$f = functionUncurryThis;
var isObject$4 = isObject$9;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;
var hasOwn$8 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$b = global$r.TypeError;
var WeakMap = global$r.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$4(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$b('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = uncurryThis$f(store.get);
  var wmhas = uncurryThis$f(store.has);
  var wmset = uncurryThis$f(store.set);
  set$1 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$b(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$8(it, STATE)) throw new TypeError$b(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$8(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$8(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var DESCRIPTORS$3 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$3 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$3 || (DESCRIPTORS$3 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var global$q = global$J;
var isCallable$b = isCallable$j;
var hasOwn$6 = hasOwnProperty_1;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
var setGlobal$1 = setGlobal$3;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$3 = internalState;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;

var getInternalState$3 = InternalStateModule$3.get;
var enforceInternalState = InternalStateModule$3.enforce;
var TEMPLATE = String(String).split('String');

(redefine$8.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  var state;
  if (isCallable$b(value)) {
    if (String(name).slice(0, 7) === 'Symbol(') {
      name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    }
    if (!hasOwn$6(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
      createNonEnumerableProperty$4(value, 'name', name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
    }
  }
  if (O === global$q) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$4(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return isCallable$b(this) && getInternalState$3(this).source || inspectSource$2(this);
});

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$3 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$1 : ceil)(number);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$3;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toIntegerOrInfinity$2(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$1 = toIntegerOrInfinity$3;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity$1(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$4 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;
var lengthOfArrayLike$3 = lengthOfArrayLike$4;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$3(O);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$e = functionUncurryThis;
var hasOwn$5 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$3 = uncurryThis$e([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$5(hiddenKeys$2, key) && hasOwn$5(O, key) && push$3(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$5(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$3(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$8;
var uncurryThis$d = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject$d = anObject$f;

var concat = uncurryThis$d([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$d(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$4 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$4 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$4.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$4(target, key) && !(exceptions && hasOwn$4(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$e = fails$l;
var isCallable$a = isCallable$j;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$a(detection) ? fails$e(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$p = global$J;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;
var redefine$7 = redefine$8.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$p;
  } else if (STATIC) {
    target = global$p[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$p[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$7(target, key, sourceProperty, options);
  }
};

var global$o = global$J;

var nativePromiseConstructor = global$o.Promise;

var redefine$6 = redefine$8.exports;

var redefineAll$2 = function (target, src, options) {
  for (var key in src) redefine$6(target, key, src[key], options);
  return target;
};

var global$n = global$J;
var isCallable$9 = isCallable$j;

var String$3 = global$n.String;
var TypeError$a = global$n.TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$9(argument)) return argument;
  throw TypeError$a("Can't set " + String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$c = functionUncurryThis;
var anObject$c = anObject$f;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$c(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$c(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$1 = objectDefineProperty.f;
var hasOwn$3 = hasOwnProperty_1;
var wellKnownSymbol$h = wellKnownSymbol$j;

var TO_STRING_TAG$3 = wellKnownSymbol$h('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$3(target, TO_STRING_TAG$3)) {
    defineProperty$1(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var getBuiltIn$4 = getBuiltIn$8;
var definePropertyModule$3 = objectDefineProperty;
var wellKnownSymbol$g = wellKnownSymbol$j;
var DESCRIPTORS$2 = descriptors;

var SPECIES$3 = wellKnownSymbol$g('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$3.f;

  if (DESCRIPTORS$2 && Constructor && !Constructor[SPECIES$3]) {
    defineProperty(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var global$m = global$J;
var isPrototypeOf$2 = objectIsPrototypeOf;

var TypeError$9 = global$m.TypeError;

var anInstance$2 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw TypeError$9('Incorrect invocation');
};

var uncurryThis$b = functionUncurryThis;
var aCallable$4 = aCallable$6;
var NATIVE_BIND$1 = functionBindNative;

var bind$5 = uncurryThis$b(uncurryThis$b.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$4(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$5(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var iterators = {};

var wellKnownSymbol$f = wellKnownSymbol$j;
var Iterators$4 = iterators;

var ITERATOR$7 = wellKnownSymbol$f('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$7] === it);
};

var wellKnownSymbol$e = wellKnownSymbol$j;

var TO_STRING_TAG$2 = wellKnownSymbol$e('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var global$l = global$J;
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$8 = isCallable$j;
var classofRaw = classofRaw$1;
var wellKnownSymbol$d = wellKnownSymbol$j;

var TO_STRING_TAG$1 = wellKnownSymbol$d('toStringTag');
var Object$2 = global$l.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$2(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$8(O.callee) ? 'Arguments' : result;
};

var classof$6 = classof$7;
var getMethod$2 = getMethod$4;
var Iterators$3 = iterators;
var wellKnownSymbol$c = wellKnownSymbol$j;

var ITERATOR$6 = wellKnownSymbol$c('iterator');

var getIteratorMethod$3 = function (it) {
  if (it != undefined) return getMethod$2(it, ITERATOR$6)
    || getMethod$2(it, '@@iterator')
    || Iterators$3[classof$6(it)];
};

var global$k = global$J;
var call$9 = functionCall;
var aCallable$3 = aCallable$6;
var anObject$b = anObject$f;
var tryToString$2 = tryToString$4;
var getIteratorMethod$2 = getIteratorMethod$3;

var TypeError$8 = global$k.TypeError;

var getIterator$2 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$2(argument) : usingIterator;
  if (aCallable$3(iteratorMethod)) return anObject$b(call$9(iteratorMethod, argument));
  throw TypeError$8(tryToString$2(argument) + ' is not iterable');
};

var call$8 = functionCall;
var anObject$a = anObject$f;
var getMethod$1 = getMethod$4;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$a(iterator);
  try {
    innerResult = getMethod$1(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$8(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$a(innerResult);
  return value;
};

var global$j = global$J;
var bind$4 = functionBindContext;
var call$7 = functionCall;
var anObject$9 = anObject$f;
var tryToString$1 = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$2 = lengthOfArrayLike$4;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator$1 = getIterator$2;
var getIteratorMethod$1 = getIteratorMethod$3;
var iteratorClose = iteratorClose$1;

var TypeError$7 = global$j.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$1 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$4(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$9(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn) throw TypeError$7(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$2(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$1(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call$7(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$b = wellKnownSymbol$j;

var ITERATOR$5 = wellKnownSymbol$b('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$5] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$5] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var uncurryThis$a = functionUncurryThis;
var fails$d = fails$l;
var isCallable$7 = isCallable$j;
var classof$5 = classof$7;
var getBuiltIn$3 = getBuiltIn$8;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$2 = uncurryThis$a(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$7(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$7(argument)) return false;
  switch (classof$5(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$2(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$1 = !construct || fails$d(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var global$i = global$J;
var isConstructor = isConstructor$1;
var tryToString = tryToString$4;

var TypeError$6 = global$i.TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError$6(tryToString(argument) + ' is not a constructor');
};

var anObject$8 = anObject$f;
var aConstructor = aConstructor$1;
var wellKnownSymbol$a = wellKnownSymbol$j;

var SPECIES$2 = wellKnownSymbol$a('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function (O, defaultConstructor) {
  var C = anObject$8(O).constructor;
  var S;
  return C === undefined || (S = anObject$8(C)[SPECIES$2]) == undefined ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$6 = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$6.bind(apply$2) : function () {
  return call$6.apply(apply$2, arguments);
});

var getBuiltIn$2 = getBuiltIn$8;

var html$2 = getBuiltIn$2('document', 'documentElement');

var uncurryThis$9 = functionUncurryThis;

var arraySlice$3 = uncurryThis$9([].slice);

var global$h = global$J;

var TypeError$5 = global$h.TypeError;

var validateArgumentsLength$2 = function (passed, required) {
  if (passed < required) throw TypeError$5('Not enough arguments');
  return passed;
};

var userAgent$4 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);

var classof$4 = classofRaw$1;
var global$g = global$J;

var engineIsNode = classof$4(global$g.process) == 'process';

var global$f = global$J;
var apply$1 = functionApply;
var bind$3 = functionBindContext;
var isCallable$6 = isCallable$j;
var hasOwn$2 = hasOwnProperty_1;
var fails$c = fails$l;
var html$1 = html$2;
var arraySlice$2 = arraySlice$3;
var createElement = documentCreateElement$2;
var validateArgumentsLength$1 = validateArgumentsLength$2;
var IS_IOS$1 = engineIsIos;
var IS_NODE$2 = engineIsNode;

var set = global$f.setImmediate;
var clear = global$f.clearImmediate;
var process$2 = global$f.process;
var Dispatch = global$f.Dispatch;
var Function$1 = global$f.Function;
var MessageChannel = global$f.MessageChannel;
var String$2 = global$f.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global$f.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$2(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$f.postMessage(String$2(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength$1(arguments.length, 1);
    var fn = isCallable$6(handler) ? handler : Function$1(handler);
    var args = arraySlice$2(arguments, 1);
    queue$1[++counter] = function () {
      apply$1(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$2) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$3(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$f.addEventListener &&
    isCallable$6(global$f.postMessage) &&
    !global$f.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$c(post)
  ) {
    defer = post;
    global$f.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html$1.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var userAgent$3 = engineUserAgent;
var global$e = global$J;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && global$e.Pebble !== undefined;

var userAgent$2 = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);

var global$d = global$J;
var bind$2 = functionBindContext;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$1 = engineIsNode;

var MutationObserver = global$d.MutationObserver || global$d.WebKitMutationObserver;
var document$2 = global$d.document;
var process$1 = global$d.process;
var Promise$1 = global$d.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global$d, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$1 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$2(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$1) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$2(macrotask, global$d);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var newPromiseCapability$2 = {};

var aCallable$2 = aCallable$6;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$2(resolve);
  this.reject = aCallable$2(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var anObject$7 = anObject$f;
var isObject$3 = isObject$9;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$7(C);
  if (isObject$3(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var global$c = global$J;

var hostReportErrors$1 = function (a, b) {
  var console = global$c.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var engineIsBrowser = typeof window == 'object';

var $$6 = _export;
var global$b = global$J;
var getBuiltIn$1 = getBuiltIn$8;
var call$5 = functionCall;
var NativePromise = nativePromiseConstructor;
var redefine$5 = redefine$8.exports;
var redefineAll$1 = redefineAll$2;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$3 = setToStringTag$4;
var setSpecies = setSpecies$1;
var aCallable$1 = aCallable$6;
var isCallable$5 = isCallable$j;
var isObject$2 = isObject$9;
var anInstance$1 = anInstance$2;
var inspectSource = inspectSource$4;
var iterate = iterate$1;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var speciesConstructor$1 = speciesConstructor$2;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var Queue = queue;
var InternalStateModule$2 = internalState;
var isForced = isForced_1;
var wellKnownSymbol$9 = wellKnownSymbol$j;
var IS_BROWSER = engineIsBrowser;
var IS_NODE = engineIsNode;
var V8_VERSION = engineV8Version;

var SPECIES$1 = wellKnownSymbol$9('species');
var PROMISE = 'Promise';

var getInternalState$2 = InternalStateModule$2.getterFor(PROMISE);
var setInternalState$2 = InternalStateModule$2.set;
var getInternalPromiseState = InternalStateModule$2.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError$4 = global$b.TypeError;
var document$1 = global$b.document;
var process = global$b.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$b.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable$5(global$b.PromiseRejectionEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED$1 = isForced(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$1] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION = FORCED$1 || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject$2(it) && isCallable$5(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$4('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$5(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$b.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$b['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$5(task, global$b, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$5(task, global$b, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$1 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$4("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$5(then, value,
            bind$1(internalResolve, wrapper, state),
            bind$1(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$1) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$1(this, PromisePrototype);
    aCallable$1(executor);
    call$5(Internal, this);
    var state = getInternalState$2(this);
    try {
      executor(bind$1(internalResolve, state), bind$1(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll$1(PromisePrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    // eslint-disable-next-line unicorn/no-thenable -- safe
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor$1(this, PromiseConstructor));
      state.parent = true;
      reaction.ok = isCallable$5(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable$5(onRejected) && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      if (state.state == PENDING) state.reactions.add(reaction);
      else microtask(function () {
        callReaction(reaction, state);
      });
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$2(promise);
    this.promise = promise;
    this.resolve = bind$1(internalResolve, state);
    this.reject = bind$1(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$5(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine$5(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$5(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine$5(NativePromisePrototype, 'catch', PromisePrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$1) {
      setPrototypeOf$1(NativePromisePrototype, PromisePrototype);
    }
  }
}

$$6({ global: true, wrap: true, forced: FORCED$1 }, {
  Promise: PromiseConstructor
});

setToStringTag$3(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn$1(PROMISE);

// statics
$$6({ target: PROMISE, stat: true, forced: FORCED$1 }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call$5(capability.reject, undefined, r);
    return capability.promise;
  }
});

$$6({ target: PROMISE, stat: true, forced: FORCED$1 }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$6({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$5($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$1(C.resolve);
      iterate(iterable, function (promise) {
        call$5($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

const saveOneAccessTokenResponse$1 = setCookie => async accessTokenResponse => {
  return new Promise(resolve => {
    setCookie('tolk_access_token', accessTokenResponse.accessToken);
    setCookie('tolk_id_token', accessTokenResponse.idToken);
    setCookie('tolk_refresh_token', accessTokenResponse.refreshToken);
    resolve();
  });
};

const saveOneAccessTokenResponse = setCookie => async accessTokenResponse => {
  await saveOneAccessTokenResponse$1(setCookie)(accessTokenResponse);
};

var index$f = /*#__PURE__*/Object.freeze({
	__proto__: null,
	saveOneAccessTokenResponse: saveOneAccessTokenResponse
});

const getOneRestAccessTokenResponse = axios => async (oauthClientId, redirectUri, code, codeVerifier, scopes, nonce) => {
  try {
    const result = await axios.post(`/v1/token`, {
      code,
      code_verifier: codeVerifier,
      grant_type: 'authorization_code',
      nonce,
      oauth_client_id: oauthClientId,
      redirect_uri: redirectUri,
      scope: scopes
    });
    return result.data;
  } catch (error) {
    if (browserUtils.isAxiosRestError(error)) {
      return null;
    }

    throw genericUtils.sanitizeError(error);
  }
};

const convertRestAccessTokenResponseToAccessTokenResponse = restAccessTokenResponse => {
  return {
    accessToken: restAccessTokenResponse.access_token,
    expiresIn: restAccessTokenResponse.expires_in,
    idToken: restAccessTokenResponse.id_token,
    refreshToken: restAccessTokenResponse.refresh_token,
    scope: restAccessTokenResponse.scope,
    tokenType: restAccessTokenResponse.token_type
  };
};

const exchangeAuthorizationCodeWithAccessToken = axios => async (oAuthClientId, redirectUri, code, codeVerifier, scopes, nonce) => {
  const result = await getOneRestAccessTokenResponse(axios)(oAuthClientId, redirectUri, code, codeVerifier, scopes.join(' '), nonce);

  if (result === null) {
    return null;
  }

  return convertRestAccessTokenResponseToAccessTokenResponse(result);
};

var index$e = /*#__PURE__*/Object.freeze({
	__proto__: null,
	exchangeAuthorizationCodeWithAccessToken: exchangeAuthorizationCodeWithAccessToken
});

const saveOneLocalAuthorizationInfos = localStorage => async localAuthorizationInfos => {
  return new Promise(resolve => {
    localStorage.setItem('tolk_authorization_infos', JSON.stringify(localAuthorizationInfos));
    resolve();
  });
};

const deleteOneLocalAuthorizationInfos = localStorage => async () => {
  return new Promise(resolve => {
    localStorage.removeItem('tolk_authorization_infos');
    resolve();
  });
};

const getOneLocalAuthorizationInfos = localStorage => async () => {
  return new Promise(resolve => {
    const localAuthorizationInfos = localStorage.getItem('tolk_authorization_infos');

    if (localAuthorizationInfos === null) {
      resolve(null);
      return;
    }

    resolve(JSON.parse(localAuthorizationInfos));
  });
};

const convertAuthorizationInfosToLocalAuhorizationInfos = authorizationInfos => {
  return {
    askedUrl: authorizationInfos.askedUrl,
    codeVerifier: authorizationInfos.codeVerifier,
    loginUrl: authorizationInfos.loginUrl,
    state: authorizationInfos.state
  };
};

const convertLocalAuthorizationInfosToAuhorizationInfos = localAuthorizationInfos => {
  return {
    askedUrl: localAuthorizationInfos.askedUrl,
    codeVerifier: localAuthorizationInfos.codeVerifier,
    loginUrl: localAuthorizationInfos.loginUrl,
    state: localAuthorizationInfos.state
  };
};

const saveOneAuthorizationInfos = localStorage => async authorizationInfos => {
  const localAuthorizationInfos = convertAuthorizationInfosToLocalAuhorizationInfos(authorizationInfos);
  await saveOneLocalAuthorizationInfos(localStorage)(localAuthorizationInfos);
};

const deleteOneAuthorizationInfos = localStorage => async () => {
  await deleteOneLocalAuthorizationInfos(localStorage)();
};

const getOneAuthorizationInfos = localStorage => async () => {
  const localAuthorizationInfos = await getOneLocalAuthorizationInfos(localStorage)();

  if (localAuthorizationInfos === null) {
    return null;
  }

  return convertLocalAuthorizationInfosToAuhorizationInfos(localAuthorizationInfos);
};

var index$d = /*#__PURE__*/Object.freeze({
	__proto__: null,
	deleteOneAuthorizationInfos: deleteOneAuthorizationInfos,
	getOneAuthorizationInfos: getOneAuthorizationInfos,
	saveOneAuthorizationInfos: saveOneAuthorizationInfos
});

const convertPgOauthClientToOauthClient = pgOauthClient => ({
  id: pgOauthClient.oauth_client_id,
  organisationId: pgOauthClient.organisation_id,
  redirectUris: pgOauthClient.redirect_uris,
  secret: pgOauthClient.secret
});

const getOnePgOauthClientById = pool => async oAuthClientId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
              oauth_client.oauth_client_id,
              oauth_client.redirect_uris,
              oauth_client.secret,
              organisation.organisation_id
            FROM oauth_client
            INNER JOIN organisation
            ON oauth_client.organisation_id = organisation.id
            WHERE oauth_client.oauth_client_id = $1`, [oAuthClientId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneOauthClientById = pool => async oAuthClientId => {
  const pgOauthClient = await getOnePgOauthClientById(pool)(oAuthClientId);

  if (pgOauthClient === null) {
    return null;
  }

  return convertPgOauthClientToOauthClient(pgOauthClient);
};

var index$c = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneOauthClientById: getOneOauthClientById
});

const convertPgOrganisationToOrganisation = pgOrganisation => ({
  id: pgOrganisation.organisation_id,
  url: pgOrganisation.url
});

const getOnePgOrganisationById = pool => async organisationId => {
  var _a;

  try {
    return (_a = (await pool.query('SELECT organisation_id, url FROM organisation WHERE organisation_id = $1', [organisationId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneOrganisationById = pool => async organisationId => {
  const pgOrganisation = await getOnePgOrganisationById(pool)(organisationId);

  if (pgOrganisation === null) {
    return null;
  }

  return convertPgOrganisationToOrganisation(pgOrganisation);
};

var index$b = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneOrganisationById: getOneOrganisationById
});

var global$a = global$J;
var classof$3 = classof$7;

var String$1 = global$a.String;

var toString$6 = function (argument) {
  if (classof$3(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String$1(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$8 = functionUncurryThis;
var requireObjectCoercible$3 = requireObjectCoercible$6;
var toString$5 = toString$6;
var whitespaces$1 = whitespaces$2;

var replace$2 = uncurryThis$8(''.replace);
var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$5(requireObjectCoercible$3($this));
    if (TYPE & 1) string = replace$2(string, ltrim, '');
    if (TYPE & 2) string = replace$2(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var PROPER_FUNCTION_NAME$2 = functionName.PROPER;
var fails$b = fails$l;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$b(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME$2 && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$5 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$5({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

const comparePassword$1 = bcryptCompare => async (password, passwordHash) => {
  try {
    const result = await bcryptCompare(password.trim(), passwordHash.trim());
    return result;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const comparePassword = bcryptCompare => async (password, passwordHash) => comparePassword$1(bcryptCompare)(password, passwordHash);

var index$a = /*#__PURE__*/Object.freeze({
	__proto__: null,
	comparePassword: comparePassword
});

var anObject$6 = anObject$f;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$6(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var uncurryThis$7 = functionUncurryThis;
var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var redefine$4 = redefine$8.exports;
var anObject$5 = anObject$f;
var isPrototypeOf = objectIsPrototypeOf;
var $toString$1 = toString$6;
var fails$a = fails$l;
var regExpFlags = regexpFlags$1;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var n$ToString = RegExpPrototype$1[TO_STRING];
var getFlags = uncurryThis$7(regExpFlags);

var NOT_GENERIC = fails$a(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$4(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$5(this);
    var p = $toString$1(R.source);
    var rf = R.flags;
    var f = $toString$1(rf === undefined && isPrototypeOf(RegExpPrototype$1, R) && !('flags' in RegExpPrototype$1) ? getFlags(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var toPropertyKey = toPropertyKey$3;
var definePropertyModule$2 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule$2.f(object, propertyKey, createPropertyDescriptor$2(0, value));
  else object[propertyKey] = value;
};

var global$9 = global$J;
var toAbsoluteIndex = toAbsoluteIndex$2;
var lengthOfArrayLike$1 = lengthOfArrayLike$4;
var createProperty = createProperty$1;

var Array$1 = global$9.Array;
var max = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike$1(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array$1(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

var arraySlice$1 = arraySliceSimple;

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice$1(array, 0, middle), comparefn),
    mergeSort(arraySlice$1(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort$1 = mergeSort;

var fails$9 = fails$l;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$9(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var userAgent$1 = engineUserAgent;

var firefox = userAgent$1.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent = engineUserAgent;

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var $$4 = _export;
var uncurryThis$6 = functionUncurryThis;
var aCallable = aCallable$6;
var toObject$1 = toObject$3;
var lengthOfArrayLike = lengthOfArrayLike$4;
var toString$4 = toString$6;
var fails$8 = fails$l;
var internalSort = arraySort$1;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var test = [];
var un$Sort = uncurryThis$6(test.sort);
var push$2 = uncurryThis$6(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$8(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$8(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails$8(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$4(x) > toString$4(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$4({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject$1(this);

    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$2(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$1 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$4 = anObject$f;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$1;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$1 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$4(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};

/* global ActiveXObject -- old IE, WSH */

var anObject$3 = anObject$f;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$3(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$8 = wellKnownSymbol$j;
var create$3 = objectCreate;
var definePropertyModule = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$8('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$1 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var fails$7 = fails$l;

var correctPrototypeGetter = !fails$7(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var global$8 = global$J;
var hasOwn$1 = hasOwnProperty_1;
var isCallable$4 = isCallable$j;
var toObject = toObject$3;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var Object$1 = global$8.Object;
var ObjectPrototype = Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$1.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn$1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$4(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$1 ? ObjectPrototype : null;
};

var fails$6 = fails$l;
var isCallable$3 = isCallable$j;
var getPrototypeOf$1 = objectGetPrototypeOf;
var redefine$3 = redefine$8.exports;
var wellKnownSymbol$7 = wellKnownSymbol$j;

var ITERATOR$4 = wellKnownSymbol$7('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$6(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$4].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$3(IteratorPrototype$2[ITERATOR$4])) {
  redefine$3(IteratorPrototype$2, ITERATOR$4, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$2 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;
var setToStringTag$2 = setToStringTag$4;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$2 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$2(IteratorPrototype$1, { next: createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$3 = _export;
var call$4 = functionCall;
var FunctionName = functionName;
var isCallable$2 = isCallable$j;
var createIteratorConstructor$1 = createIteratorConstructor$2;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$4;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$6;
var redefine$2 = redefine$8.exports;
var wellKnownSymbol$6 = wellKnownSymbol$j;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol$6('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$2(CurrentIteratorPrototype[ITERATOR$3])) {
          redefine$2(CurrentIteratorPrototype, ITERATOR$3, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$4(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$3({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$3] !== defaultIterator) {
    redefine$2(IterablePrototype, ITERATOR$3, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables = addToUnscopables$1;
var Iterators = iterators;
var InternalStateModule$1 = internalState;
var defineProperty = objectDefineProperty.f;
var defineIterator = defineIterator$1;
var DESCRIPTORS = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$7 = global$J;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$6;
var wellKnownSymbol$5 = wellKnownSymbol$j;

var ITERATOR$2 = wellKnownSymbol$5('iterator');
var TO_STRING_TAG = wellKnownSymbol$5('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$7[COLLECTION_NAME] && global$7[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var fails$5 = fails$l;
var global$6 = global$J;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$6.RegExp;

var UNSUPPORTED_Y$2 = fails$5(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$2 || fails$5(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$5(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var fails$4 = fails$l;
var global$5 = global$J;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$5.RegExp;

var regexpUnsupportedDotAll = fails$4(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$3 = fails$l;
var global$4 = global$J;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$4.RegExp;

var regexpUnsupportedNcg = fails$3(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$3 = functionCall;
var uncurryThis$5 = functionUncurryThis;
var toString$3 = toString$6;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$4.exports;
var create$1 = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$5(''.charAt);
var indexOf = uncurryThis$5(''.indexOf);
var replace$1 = uncurryThis$5(''.replace);
var stringSlice$3 = uncurryThis$5(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$3(nativeExec, re1, 'a');
  call$3(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$3(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$3(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$3(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$1(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$3(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$3(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$3(match.input, charsAdded);
        match[0] = stringSlice$3(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call$3(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$1(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$3 = patchedExec;

var $$2 = _export;
var exec$1 = regexpExec$3;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$2({ target: 'RegExp', proto: true, forced: /./.exec !== exec$1 }, {
  exec: exec$1
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$4 = functionUncurryThis;
var redefine$1 = redefine$8.exports;
var regexpExec$2 = regexpExec$3;
var fails$2 = fails$l;
var wellKnownSymbol$4 = wellKnownSymbol$j;
var createNonEnumerableProperty = createNonEnumerableProperty$6;

var SPECIES = wellKnownSymbol$4('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$4(KEY);

  var DELEGATES_TO_SYMBOL = !fails$2(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$2(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$4(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$4(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$2 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine$1(String.prototype, KEY, methods[0]);
    redefine$1(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var isObject$1 = isObject$9;
var classof$2 = classofRaw$1;
var wellKnownSymbol$3 = wellKnownSymbol$j;

var MATCH$1 = wellKnownSymbol$3('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$1(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$2(it) == 'RegExp');
};

var uncurryThis$3 = functionUncurryThis;
var toIntegerOrInfinity = toIntegerOrInfinity$3;
var toString$2 = toString$6;
var requireObjectCoercible$2 = requireObjectCoercible$6;

var charAt$2 = uncurryThis$3(''.charAt);
var charCodeAt = uncurryThis$3(''.charCodeAt);
var stringSlice$2 = uncurryThis$3(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$2(requireObjectCoercible$2($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var global$3 = global$J;
var call$2 = functionCall;
var anObject$2 = anObject$f;
var isCallable$1 = isCallable$j;
var classof$1 = classofRaw$1;
var regexpExec$1 = regexpExec$3;

var TypeError$3 = global$3.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$1(exec)) {
    var result = call$2(exec, R, S);
    if (result !== null) anObject$2(result);
    return result;
  }
  if (classof$1(R) === 'RegExp') return call$2(regexpExec$1, R, S);
  throw TypeError$3('RegExp#exec called on incompatible receiver');
};

var apply = functionApply;
var call$1 = functionCall;
var uncurryThis$2 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var isRegExp$1 = isRegexp;
var anObject$1 = anObject$f;
var requireObjectCoercible$1 = requireObjectCoercible$6;
var speciesConstructor = speciesConstructor$2;
var advanceStringIndex = advanceStringIndex$1;
var toLength = toLength$2;
var toString$1 = toString$6;
var getMethod = getMethod$4;
var arraySlice = arraySliceSimple;
var callRegExpExec = regexpExecAbstract;
var regexpExec = regexpExec$3;
var stickyHelpers = regexpStickyHelpers;
var fails$1 = fails$l;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis$2(/./.exec);
var push$1 = uncurryThis$2($push);
var stringSlice$1 = uncurryThis$2(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$1(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString$1(requireObjectCoercible$1(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp$1(separator)) {
        return call$1(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call$1(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push$1(output, stringSlice$1(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push$1(output, '');
      } else push$1(output, stringSlice$1(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call$1(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$1(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call$1(splitter, separator, O, limit)
        : call$1(internalSplit, toString$1(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject$1(this);
      var S = toString$1(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice$1(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$1(A, stringSlice$1(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$1(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$1(A, stringSlice$1(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

const convertDecodeJwtToAuthorizationCodeContent = jwtAuthorizationCode => ({
  codeChallenge: jwtAuthorizationCode.code_challenge,
  expirationDate: jwtAuthorizationCode.exp,
  id: jwtAuthorizationCode.id,
  oAuthClientId: jwtAuthorizationCode.azp,
  redirectUri: jwtAuthorizationCode.redirect_uri,
  userId: jwtAuthorizationCode.sub
});

const base64UrlEncode = string => encodeURIComponent(Buffer.from(string).toString('base64'));

const sha256 = crypto => string => crypto.createHash('sha256').update(string).digest('hex');

const encodeVerifier = crypto => codeVerifier => base64UrlEncode(sha256(crypto)(codeVerifier));

const isCodeContent = code => {
  const keyCode = ['azp', 'code_challenge', 'exp', 'iat', 'id', 'redirect_uri', 'sub'];
  return genericUtils.isObject(code) && [...Object.keys(code)].sort((valueA, valueB) => valueA.localeCompare(valueB)).every((value, index) => value === keyCode[index]);
};

const isRefreshTokenContent = refreshToken => {
  const keyRefreshToken = ['aud', 'azp', 'exp', 'iat', 'iss', 'nonce', 'scope', 'sub'];
  return genericUtils.isObject(refreshToken) && [...Object.keys(refreshToken)].sort((valueA, valueB) => valueA.localeCompare(valueB)).every((value, index) => value === keyRefreshToken[index]);
};

const isAccessTokenContent = accessToken => {
  const keysAccessToken = ['aud', 'azp', 'exp', 'iat', 'iss', 'nonce', 'scope', 'sub'];
  return genericUtils.isObject(accessToken) && [...Object.keys(accessToken)].sort((valueA, valueB) => valueA.localeCompare(valueB)).every((value, index) => value === keysAccessToken[index]);
};

const generateIssueDateWithExpirateDateAfterOneHour = () => {
  const issueDate = Math.floor(Date.now() / genericUtils.TIME.MILLISECONDS_IN_A_SECOND);
  const expirateDate = issueDate + genericUtils.TIME.SECONDS_IN_AN_HOUR;
  return {
    expirateDate,
    issueDate
  };
};

const generateIssueDateWithExpirateDateAfterOneMonth = () => {
  const issueDate = Math.floor(Date.now() / genericUtils.TIME.MILLISECONDS_IN_A_SECOND);
  const expirateDate = issueDate + genericUtils.TIME.SECONDS_IN_A_MONTH;
  return {
    expirateDate,
    issueDate
  };
};

const convertJwtAccessTokenToAccessToken = jwtAccessToken => ({
  expirationDate: new Date(jwtAccessToken.exp * genericUtils.TIME.MILLISECONDS_IN_A_SECOND),
  oAuthClientId: jwtAccessToken.azp,
  scopes: jwtAccessToken.scope.split(','),
  userId: jwtAccessToken.sub
});

const encodeAuthorizationCode = (jwtSign, jwtSecretKey) => (oauthClientId, redirectUri, codeChallenge, userId) => {
  const jwtSignEncode = {
    azp: oauthClientId,
    code_challenge: codeChallenge,
    id: genericUtils.generateUniqueId(),
    redirect_uri: redirectUri,
    sub: userId
  };
  return jwtSign(jwtSignEncode, jwtSecretKey, {
    expiresIn: genericUtils.TIME.SECONDS_IN_A_MINUTE
  });
};

const decodeAuthorizationCode = (jwtVerify, jwtSecretKey) => code => {
  try {
    const result = jwtVerify(code, jwtSecretKey);

    if (isCodeContent(result)) {
      return convertDecodeJwtToAuthorizationCodeContent(result);
    }

    return null;
  } catch (_a) {
    return null;
  }
};

const validateCodeVerifier = crypto => (codeVerifier, codeChallenge) => {
  return encodeVerifier(crypto)(codeVerifier) === codeChallenge;
};

const encodeAccessToken = jwtSign => (issuer, userId, audienceUrl, oAuthClientId, scope, nonce, secret) => {
  const issueDateWithExpirate = generateIssueDateWithExpirateDateAfterOneHour();
  const jwtAccessToken = {
    aud: audienceUrl,
    azp: oAuthClientId,
    exp: issueDateWithExpirate.expirateDate,
    iat: issueDateWithExpirate.issueDate,
    iss: issuer,
    nonce,
    scope,
    sub: userId
  };
  return jwtSign(jwtAccessToken, secret);
};

const encodeIdToken = jwtSign => (issuer, userId, audienceUrl, oAuthClientId, nonce, scope, firstName, lastName, email, secret // eslint-disable-next-line max-params
) => {
  const issueDateWithExpirate = generateIssueDateWithExpirateDateAfterOneMonth();
  const jwtIdToken = {
    aud: audienceUrl,
    azp: oAuthClientId,
    email,
    exp: issueDateWithExpirate.expirateDate,
    family_name: lastName,
    given_name: firstName,
    iat: issueDateWithExpirate.issueDate,
    iss: issuer,
    nonce,
    scope,
    sub: userId
  };
  return jwtSign(jwtIdToken, secret);
};

const encodeRefreshToken = jwtSign => (issuer, userId, audienceUrl, oAuthClientId, nonce, scope, secret) => {
  const issueDateWithExpirate = generateIssueDateWithExpirateDateAfterOneMonth();
  const jwtRefreshToken = {
    aud: audienceUrl,
    azp: oAuthClientId,
    exp: issueDateWithExpirate.expirateDate,
    iat: issueDateWithExpirate.issueDate,
    iss: issuer,
    nonce,
    scope,
    sub: userId
  };
  return jwtSign(jwtRefreshToken, secret);
};

const decodeRefreshToken = jwtVerify => (refreshToken, secret) => {
  try {
    const result = jwtVerify(refreshToken, secret);

    if (!isRefreshTokenContent(result)) {
      return null;
    }

    return result;
  } catch (_a) {
    return null;
  }
};

const verifyAccessToken = (jwtVerify, authManagementBaseUrl) => (accessToken, secret, audience) => {
  try {
    const verify = {
      audience,
      authManagementBaseUrl
    };
    const result = jwtVerify(accessToken, secret, verify);

    if (!isAccessTokenContent(result)) {
      return false;
    }

    return true;
  } catch (_a) {
    return false;
  }
};

const decodeAccessToken = jwtDecode => accessToken => {
  try {
    const result = jwtDecode(accessToken);

    if (!isAccessTokenContent(result)) {
      return null;
    }

    return convertJwtAccessTokenToAccessToken(result);
  } catch (_a) {
    return null;
  }
};

var index$9 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	decodeAccessToken: decodeAccessToken,
	decodeAuthorizationCode: decodeAuthorizationCode,
	decodeRefreshToken: decodeRefreshToken,
	encodeAccessToken: encodeAccessToken,
	encodeAuthorizationCode: encodeAuthorizationCode,
	encodeIdToken: encodeIdToken,
	encodeRefreshToken: encodeRefreshToken,
	validateCodeVerifier: validateCodeVerifier,
	verifyAccessToken: verifyAccessToken
});

const convertPgUserSessionToUserSession = pgUserSession => ({
  oAuthClientId: pgUserSession.oauth_client_id,
  refreshToken: pgUserSession.refresh_token,
  userId: pgUserSession.user_id
});

const saveOnePgUserSession = pool => async userSession => {
  try {
    await pool.query(`INSERT INTO user_session (
        user_id,
        oauth_client_id,
        refresh_token
    ) VALUES (
      (SELECT "user".id FROM "user" WHERE "user".user_id = $1),
      (SELECT "oauth_client".id FROM "oauth_client" WHERE "oauth_client".oauth_client_id = $2),
      $3)
    ON CONFLICT (user_id) DO UPDATE SET
    oauth_client_id=(SELECT "oauth_client".id FROM "oauth_client" WHERE "oauth_client".oauth_client_id = $2),
    refresh_token=$3`, [userSession.userId, userSession.oAuthClientId, userSession.refreshToken]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgUserSessionByRefreshToken = pool => async refreshToken => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
            "user".user_id,
            "oauth_client".oauth_client_id,
            refresh_token
          FROM user_session
          INNER JOIN "user" ON "user".id = user_session.user_id
          INNER JOIN "oauth_client" ON "oauth_client".id = user_session.oauth_client_id
          WHERE refresh_token = $1`, [refreshToken])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteOnePgUserSessionByRefreshToken = pool => async refreshToken => {
  try {
    await pool.query(`DELETE FROM user_session WHERE refresh_token = $1;`, [refreshToken]);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const saveOneUserSession = pool => async userSession => {
  await saveOnePgUserSession(pool)(userSession);
};

const getOneUserSessionByRefreshToken = pool => async refreshToken => {
  try {
    const pgUserSession = await getOnePgUserSessionByRefreshToken(pool)(refreshToken);

    if (pgUserSession === null) {
      return null;
    }

    return convertPgUserSessionToUserSession(pgUserSession);
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const deleteOneUserSessionByRefreshToken = pool => async refreshToken => {
  await deleteOnePgUserSessionByRefreshToken(pool)(refreshToken);
};

var index$8 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	deleteOneUserSessionByRefreshToken: deleteOneUserSessionByRefreshToken,
	getOneUserSessionByRefreshToken: getOneUserSessionByRefreshToken,
	saveOneUserSession: saveOneUserSession
});

const convertPgUserToUser = pgUser => ({
  email: pgUser.email,
  firstName: pgUser.first_name,
  id: pgUser.user_id,
  jobTitle: pgUser.job_title,
  lastName: pgUser.last_name,
  passwordHash: pgUser.password_hash
});

const getOnePgUserByEmail = pool => async email => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
              "user".user_id,
              "user".email,
              "user".password_hash,
              "user_profile".first_name,
              "user_profile".job_title,
              "user_profile".last_name
           FROM "user"
           INNER JOIN user_profile ON user_profile.user_id = "user".id
           WHERE "user".email = $1`, [email])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOnePgUserById = pool => async userId => {
  var _a;

  try {
    return (_a = (await pool.query(`SELECT
              "user".user_id,
              email,
              password_hash,
              "user_profile".first_name,
              "user_profile".job_title,
              "user_profile".last_name
          FROM "user"
          INNER JOIN user_profile ON user_profile.user_id = "user".id
          WHERE "user".user_id = $1`, [userId])).rows[genericUtils.ARRAY.FIRST_INDEX]) !== null && _a !== void 0 ? _a : null;
  } catch (error) {
    throw genericUtils.sanitizeError(error);
  }
};

const getOneUserByEmail = pool => async email => {
  const pgUser = await getOnePgUserByEmail(pool)(email);

  if (pgUser === null) {
    return null;
  }

  return convertPgUserToUser(pgUser);
};

const getOneUserById = pool => async userId => {
  const pgUser = await getOnePgUserById(pool)(userId);

  if (pgUser === null) {
    return null;
  }

  return convertPgUserToUser(pgUser);
};

var index$7 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	getOneUserByEmail: getOneUserByEmail,
	getOneUserById: getOneUserById
});

var $schema = "http://json-schema.org/draft-07/schema#";
var definitions = {
	OrganisationId: {
		type: "string"
	},
	OrganisationUrl: {
		type: "string"
	},
	Organisation: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/OrganisationId"
			},
			url: {
				$ref: "#/definitions/OrganisationUrl"
			}
		},
		required: [
			"id",
			"url"
		],
		additionalProperties: false
	},
	OauthClientId: {
		type: "string"
	},
	OauthClientSecret: {
		type: "string"
	},
	RedirectUri: {
		type: "string"
	},
	CodeVerifier: {
		type: "string"
	},
	OauthClient: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/OauthClientId"
			},
			secret: {
				$ref: "#/definitions/OauthClientSecret"
			},
			redirectUris: {
				type: "array",
				items: {
					$ref: "#/definitions/RedirectUri"
				}
			},
			organisationId: {
				$ref: "#/definitions/OrganisationId"
			}
		},
		required: [
			"id",
			"secret",
			"redirectUris",
			"organisationId"
		],
		additionalProperties: false
	},
	AuthorizationInfosState: {
		type: "string"
	},
	AuthorizationInfos: {
		type: "object",
		properties: {
			codeVerifier: {
				type: "string"
			},
			state: {
				type: "string"
			},
			loginUrl: {
				type: "string"
			},
			askedUrl: {
				type: "string"
			}
		},
		required: [
			"codeVerifier",
			"state",
			"loginUrl",
			"askedUrl"
		],
		additionalProperties: false
	},
	State: {
		type: "string"
	},
	Code: {
		type: "string"
	},
	AuthorizationResponse: {
		type: "object",
		properties: {
			code: {
				$ref: "#/definitions/Code"
			},
			state: {
				$ref: "#/definitions/State"
			}
		},
		required: [
			"code",
			"state"
		],
		additionalProperties: false
	},
	CodeChallenge: {
		type: "string"
	},
	AuthorizationCodeContent: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			oAuthClientId: {
				$ref: "#/definitions/OauthClientId"
			},
			redirectUri: {
				$ref: "#/definitions/RedirectUri"
			},
			userId: {
				$ref: "#/definitions/UserId"
			},
			codeChallenge: {
				$ref: "#/definitions/CodeChallenge"
			},
			expirationDate: {
				type: "number"
			}
		},
		required: [
			"id",
			"oAuthClientId",
			"redirectUri",
			"userId",
			"codeChallenge",
			"expirationDate"
		],
		additionalProperties: false
	},
	UserId: {
		type: "string"
	},
	RefreshTokenContent: {
		type: "object",
		properties: {
			azp: {
				type: "string"
			},
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			nonce: {
				type: "string"
			},
			scope: {
				type: "string"
			},
			exp: {
				type: "number"
			}
		},
		required: [
			"azp",
			"iss",
			"sub",
			"aud",
			"iat",
			"nonce",
			"scope",
			"exp"
		],
		additionalProperties: false
	},
	TokenType: {
		type: "string",
		"const": "bearer"
	},
	RefreshToken: {
		type: "string"
	},
	AccessToken: {
		type: "string"
	},
	Nonce: {
		type: "string"
	},
	Scope: {
		type: "string"
	},
	Scopes: {
		type: "array",
		items: {
			$ref: "#/definitions/Scope"
		}
	},
	Issuer: {
		type: "string"
	},
	AudienceUrl: {
		type: "string"
	},
	AccessTokenResponse: {
		type: "object",
		properties: {
			accessToken: {
				type: "string"
			},
			refreshToken: {
				$ref: "#/definitions/RefreshToken"
			},
			idToken: {
				type: "string"
			},
			scope: {
				$ref: "#/definitions/Scope"
			},
			tokenType: {
				$ref: "#/definitions/TokenType"
			},
			expiresIn: {
				type: "number",
				"const": 3600
			}
		},
		required: [
			"accessToken",
			"refreshToken",
			"idToken",
			"scope",
			"tokenType",
			"expiresIn"
		],
		additionalProperties: false
	},
	UserEmail: {
		type: "string"
	},
	UserPasswordHash: {
		type: "string"
	},
	UserPassword: {
		type: "string"
	},
	JobTitle: {
		type: "string",
		"enum": [
			"admin-ops",
			"customer support",
			"sales",
			"marketing",
			"other"
		]
	},
	UserFirstName: {
		type: "string"
	},
	UserLastName: {
		type: "string"
	},
	User: {
		type: "object",
		properties: {
			id: {
				$ref: "#/definitions/UserId"
			},
			email: {
				$ref: "#/definitions/UserEmail"
			},
			passwordHash: {
				$ref: "#/definitions/UserPasswordHash"
			},
			firstName: {
				$ref: "#/definitions/UserFirstName"
			},
			lastName: {
				$ref: "#/definitions/UserLastName"
			},
			jobTitle: {
				$ref: "#/definitions/JobTitle"
			}
		},
		required: [
			"id",
			"email",
			"passwordHash",
			"firstName",
			"lastName",
			"jobTitle"
		],
		additionalProperties: false
	},
	UserSession: {
		type: "object",
		properties: {
			userId: {
				$ref: "#/definitions/UserId"
			},
			oAuthClientId: {
				$ref: "#/definitions/OauthClientId"
			},
			refreshToken: {
				$ref: "#/definitions/RefreshToken"
			}
		},
		required: [
			"userId",
			"oAuthClientId",
			"refreshToken"
		],
		additionalProperties: false
	},
	AccessTokenInfos: {
		type: "object",
		properties: {
			oAuthClientId: {
				$ref: "#/definitions/OauthClientId"
			},
			expirationDate: {
				type: "string",
				format: "date-time"
			},
			scopes: {
				type: "array",
				items: {
					type: "string"
				}
			},
			userId: {
				$ref: "#/definitions/UserId"
			}
		},
		required: [
			"oAuthClientId",
			"expirationDate",
			"scopes",
			"userId"
		],
		additionalProperties: false
	},
	RefreshTokenResponse: {
		type: "object",
		properties: {
			accessToken: {
				type: "string"
			},
			idToken: {
				type: "string"
			},
			scope: {
				$ref: "#/definitions/Scope"
			},
			tokenType: {
				$ref: "#/definitions/TokenType"
			},
			expiresIn: {
				type: "number",
				"const": 3600
			}
		},
		required: [
			"accessToken",
			"idToken",
			"scope",
			"tokenType",
			"expiresIn"
		],
		additionalProperties: false
	},
	CookiesAccessTokenResponse: {
		type: "object",
		properties: {
			accessToken: {
				type: "string"
			},
			refreshToken: {
				type: "string"
			},
			idToken: {
				type: "string"
			},
			scope: {
				type: "string"
			},
			tokenType: {
				type: "string",
				"const": "bearer"
			},
			expiresIn: {
				type: "number",
				"const": 3600
			}
		},
		required: [
			"accessToken",
			"refreshToken",
			"idToken",
			"scope",
			"tokenType",
			"expiresIn"
		],
		additionalProperties: false
	},
	RestAuthorizationCodeRequest: {
		type: "object",
		properties: {
			grant_type: {
				type: "string",
				"const": "authorization_code"
			},
			code: {
				type: "string"
			},
			redirect_uri: {
				type: "string"
			},
			nonce: {
				type: "string"
			},
			oauth_client_id: {
				type: "string"
			},
			scopes: {
				type: "array",
				items: {
					type: "string"
				}
			},
			code_verifier: {
				type: "string"
			}
		},
		required: [
			"grant_type",
			"code",
			"redirect_uri",
			"nonce",
			"oauth_client_id",
			"scopes",
			"code_verifier"
		],
		additionalProperties: false
	},
	RestAccessTokenResponse: {
		type: "object",
		properties: {
			access_token: {
				type: "string"
			},
			refresh_token: {
				type: "string"
			},
			id_token: {
				type: "string"
			},
			scope: {
				type: "string"
			},
			token_type: {
				type: "string",
				"const": "bearer"
			},
			expires_in: {
				type: "number"
			}
		},
		required: [
			"access_token",
			"refresh_token",
			"id_token",
			"scope",
			"token_type",
			"expires_in"
		],
		additionalProperties: false
	},
	LocalAuthorizationInfos: {
		type: "object",
		properties: {
			codeVerifier: {
				type: "string"
			},
			state: {
				type: "string"
			},
			loginUrl: {
				type: "string"
			},
			askedUrl: {
				type: "string"
			}
		},
		required: [
			"codeVerifier",
			"state",
			"loginUrl",
			"askedUrl"
		],
		additionalProperties: false
	},
	PgOauthClient: {
		type: "object",
		properties: {
			redirect_uris: {
				type: "array",
				items: {
					type: "string"
				}
			},
			oauth_client_id: {
				type: "string"
			},
			secret: {
				type: "string"
			},
			organisation_id: {
				type: "string"
			}
		},
		required: [
			"redirect_uris",
			"oauth_client_id",
			"secret",
			"organisation_id"
		],
		additionalProperties: false
	},
	PgOrganisation: {
		type: "object",
		properties: {
			organisation_id: {
				type: "string"
			},
			url: {
				type: "string"
			}
		},
		required: [
			"organisation_id",
			"url"
		],
		additionalProperties: false
	},
	JwtSecretKey: {
		type: "string"
	},
	JwtAuthorizationCode: {
		type: "object",
		properties: {
			id: {
				type: "string"
			},
			azp: {
				$ref: "#/definitions/OauthClientId"
			},
			code_challenge: {
				$ref: "#/definitions/CodeChallenge"
			},
			redirect_uri: {
				$ref: "#/definitions/RedirectUri"
			},
			sub: {
				$ref: "#/definitions/UserId"
			},
			exp: {
				type: "number"
			},
			iat: {
				type: "number"
			}
		},
		required: [
			"id",
			"azp",
			"code_challenge",
			"redirect_uri",
			"sub",
			"exp",
			"iat"
		],
		additionalProperties: false
	},
	JwtAccessToken: {
		type: "object",
		properties: {
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			nonce: {
				type: "string"
			},
			exp: {
				type: "number"
			},
			scope: {
				type: "string"
			},
			azp: {
				type: "string"
			}
		},
		required: [
			"iss",
			"sub",
			"aud",
			"iat",
			"nonce",
			"exp",
			"scope",
			"azp"
		],
		additionalProperties: false
	},
	JwtIdToken: {
		type: "object",
		properties: {
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			nonce: {
				type: "string"
			},
			exp: {
				type: "number"
			},
			scope: {
				type: "string"
			},
			email: {
				type: "string"
			},
			given_name: {
				type: "string"
			},
			family_name: {
				type: "string"
			},
			azp: {
				type: "string"
			}
		},
		required: [
			"iss",
			"sub",
			"aud",
			"iat",
			"nonce",
			"exp",
			"scope",
			"email",
			"given_name",
			"family_name",
			"azp"
		],
		additionalProperties: false
	},
	JwtRefreshToken: {
		type: "object",
		properties: {
			azp: {
				type: "string"
			},
			iss: {
				type: "string"
			},
			sub: {
				type: "string"
			},
			aud: {
				type: "string"
			},
			iat: {
				type: "number"
			},
			nonce: {
				type: "string"
			},
			exp: {
				type: "number"
			},
			scope: {
				type: "string"
			}
		},
		required: [
			"azp",
			"iss",
			"sub",
			"aud",
			"iat",
			"nonce",
			"exp",
			"scope"
		],
		additionalProperties: false
	},
	PgUserSession: {
		type: "object",
		properties: {
			user_id: {
				type: "string"
			},
			oauth_client_id: {
				type: "string"
			},
			refresh_token: {
				type: "string"
			}
		},
		required: [
			"user_id",
			"oauth_client_id",
			"refresh_token"
		],
		additionalProperties: false
	},
	PgJobTitle: {
		type: "string",
		"enum": [
			"admin-ops",
			"customer support",
			"sales",
			"marketing",
			"other"
		]
	},
	PgUser: {
		type: "object",
		properties: {
			user_id: {
				type: "string"
			},
			email: {
				type: "string"
			},
			password_hash: {
				type: "string"
			},
			first_name: {
				type: "string"
			},
			job_title: {
				$ref: "#/definitions/PgJobTitle"
			},
			last_name: {
				type: "string"
			}
		},
		required: [
			"user_id",
			"email",
			"password_hash",
			"first_name",
			"job_title",
			"last_name"
		],
		additionalProperties: false
	}
};
var entitiesSchemas = {
	$schema: $schema,
	definitions: definitions
};

var entitiesSchemas$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	$schema: $schema,
	definitions: definitions,
	'default': entitiesSchemas
});

const accessTokenResponseFactory = (encodeAccessToken, encodeIdToken, encodeRefreshToken) => (issuer, nonce, scopes, user, oauthClientId, audienceUrl, secret) => {
  const scopesString = scopes.join(' ');
  const accessToken = encodeAccessToken(issuer, user.id, audienceUrl, oauthClientId, scopesString, nonce, secret);
  const idToken = encodeIdToken(issuer, user.id, audienceUrl, oauthClientId, nonce, scopesString, user.firstName, user.lastName, user.email, secret);
  const refreshToken = encodeRefreshToken(issuer, user.id, audienceUrl, oauthClientId, nonce, scopesString, secret);
  return {
    accessToken,
    expiresIn: genericUtils.TIME.SECONDS_IN_AN_HOUR,
    idToken,
    refreshToken,
    scope: scopesString,
    tokenType: 'bearer'
  };
};

var index$6 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	accessTokenResponseFactory: accessTokenResponseFactory
});

var fails = fails$l;
var wellKnownSymbol$2 = wellKnownSymbol$j;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$2('iterator');

var nativeUrl = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$1 = _export;
var global$2 = global$J;
var getBuiltIn = getBuiltIn$8;
var call = functionCall;
var uncurryThis$1 = functionUncurryThis;
var USE_NATIVE_URL = nativeUrl;
var redefine = redefine$8.exports;
var redefineAll = redefineAll$2;
var setToStringTag = setToStringTag$4;
var createIteratorConstructor = createIteratorConstructor$2;
var InternalStateModule = internalState;
var anInstance = anInstance$2;
var isCallable = isCallable$j;
var hasOwn = hasOwnProperty_1;
var bind = functionBindContext;
var classof = classof$7;
var anObject = anObject$f;
var isObject = isObject$9;
var $toString = toString$6;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$5;
var getIterator = getIterator$2;
var getIteratorMethod = getIteratorMethod$3;
var validateArgumentsLength = validateArgumentsLength$2;
var wellKnownSymbol$1 = wellKnownSymbol$j;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol$1('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var n$Fetch = getBuiltIn('fetch');
var N$Request = getBuiltIn('Request');
var Headers = getBuiltIn('Headers');
var RequestPrototype = N$Request && N$Request.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$2.RegExp;
var TypeError$2 = global$2.TypeError;
var decodeURIComponent = global$2.decodeURIComponent;
var encodeURIComponent$1 = global$2.encodeURIComponent;
var charAt = uncurryThis$1(''.charAt);
var join = uncurryThis$1([].join);
var push = uncurryThis$1([].push);
var replace = uncurryThis$1(''.replace);
var shift = uncurryThis$1([].shift);
var splice = uncurryThis$1([].splice);
var split = uncurryThis$1(''.split);
var stringSlice = uncurryThis$1(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError$2('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$1({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis$1(HeadersPrototype.has);
  var headersSet = uncurryThis$1(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(n$Fetch)) {
    $$1({ global: true, enumerable: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return n$Fetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(N$Request)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new N$Request(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$1({ global: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

const generateCodeVerifier = () => {
  const allowedCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  const codeVerifierLength = 128;
  return genericUtils.generateRandomString(codeVerifierLength, allowedCharacters);
};

const generateCodeChallenge = base64Encode => codeVerifier => {
  const codeVerifierHash = cryptojs.SHA256(codeVerifier).toString();
  return encodeURIComponent(base64Encode(codeVerifierHash));
};

const generateAuthorizeUrl = authManagementBaseUrl => (codeChallenge, oAuthClientId, state, redirectUri) => {
  const searchParameters = new URLSearchParams();
  searchParameters.append('code_challenge_method', 'S256');
  searchParameters.append('code_challenge', codeChallenge);
  searchParameters.append('response_type', 'code');
  searchParameters.append('oauth_client_id', oAuthClientId);
  searchParameters.append('state', state);
  searchParameters.append('redirect_uri', redirectUri);
  return `${authManagementBaseUrl}/v1/authorize?${searchParameters.toString()}`;
};

const authorizationInfosFactory = (authManagementBaseUrl, base64Encode) => (oAuthClientId, redirectUri, askedUrl) => {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = generateCodeChallenge(base64Encode)(codeVerifier);
  const state = genericUtils.generateRandomString();
  const loginUrl = generateAuthorizeUrl(authManagementBaseUrl)(codeChallenge, oAuthClientId, state, redirectUri);
  return {
    askedUrl,
    codeVerifier,
    loginUrl,
    state
  };
};

var index$5 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	authorizationInfosFactory: authorizationInfosFactory
});

var index$4 = /*#__PURE__*/Object.freeze({
	__proto__: null
});

var index$3 = /*#__PURE__*/Object.freeze({
	__proto__: null
});

const refreshTokenResponseFactory = (encodeAccessToken, encodeIdToken) => (issuer, nonce, scopes, user, oAuthClientId, audienceUrl, secret) => {
  const scopesString = scopes.join(' ');
  const accessToken = encodeAccessToken(issuer, user.id, audienceUrl, oAuthClientId, scopesString, nonce, secret);
  const idToken = encodeIdToken(issuer, user.id, audienceUrl, oAuthClientId, nonce, scopesString, user.firstName, user.lastName, user.email, secret);
  return {
    accessToken,
    expiresIn: genericUtils.TIME.SECONDS_IN_AN_HOUR,
    idToken,
    scope: scopesString,
    tokenType: 'bearer'
  };
};

var index$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	refreshTokenResponseFactory: refreshTokenResponseFactory
});

var ErrorValidationScope;

(function (ErrorValidationScope) {
  ErrorValidationScope[ErrorValidationScope["invalidScope"] = 0] = "invalidScope";
})(ErrorValidationScope || (ErrorValidationScope = {}));

const scopesRequired = ['openid', 'profile', 'email'];

const areRequiredScopesExisting = scopes => {
  const filterScopeRequired = scopes.filter(item => scopesRequired.includes(item));
  return filterScopeRequired.length === scopesRequired.length;
};

var ValidateScopesErrors;

(function (ValidateScopesErrors) {
  ValidateScopesErrors[ValidateScopesErrors["emptyScopes"] = 0] = "emptyScopes";
  ValidateScopesErrors[ValidateScopesErrors["missingRequiredScopes"] = 1] = "missingRequiredScopes";
})(ValidateScopesErrors || (ValidateScopesErrors = {}));

const validateScopes = scopes => {
  if (scopes.length === genericUtils.ARRAY.EMPTY_LENGTH) {
    return ValidateScopesErrors.emptyScopes;
  }

  if (areRequiredScopesExisting(scopes) === false) {
    return ValidateScopesErrors.missingRequiredScopes;
  }
};

var index$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	validateScopes: validateScopes,
	get ValidateScopesErrors () { return ValidateScopesErrors; }
});

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	scopesValidation: index$1
});

var AuthorizeErrors;

(function (AuthorizeErrors) {
  AuthorizeErrors[AuthorizeErrors["inexistingOAuthClient"] = 0] = "inexistingOAuthClient";
  AuthorizeErrors[AuthorizeErrors["unregisteredRedirectUri"] = 1] = "unregisteredRedirectUri";
})(AuthorizeErrors || (AuthorizeErrors = {}));

var GetOneAccessTokenInfosErrors;

(function (GetOneAccessTokenInfosErrors) {
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["invalidAccessToken"] = 0] = "invalidAccessToken";
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["inexistingOAuthClient"] = 1] = "inexistingOAuthClient";
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["inexistingOrganisation"] = 2] = "inexistingOrganisation";
  GetOneAccessTokenInfosErrors[GetOneAccessTokenInfosErrors["inexistingUser"] = 3] = "inexistingUser";
})(GetOneAccessTokenInfosErrors || (GetOneAccessTokenInfosErrors = {}));

var AuthenticateErrors;

(function (AuthenticateErrors) {
  AuthenticateErrors[AuthenticateErrors["inexistingOAuthClient"] = 0] = "inexistingOAuthClient";
  AuthenticateErrors[AuthenticateErrors["unregisteredRedirectUri"] = 1] = "unregisteredRedirectUri";
  AuthenticateErrors[AuthenticateErrors["inexistingUser"] = 2] = "inexistingUser";
  AuthenticateErrors[AuthenticateErrors["invalidPassword"] = 3] = "invalidPassword";
})(AuthenticateErrors || (AuthenticateErrors = {}));

var AuthorizationCodeExchangeErrors;

(function (AuthorizationCodeExchangeErrors) {
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["inexistingOAuthClient"] = 0] = "inexistingOAuthClient";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["unregisteredRedirectUri"] = 1] = "unregisteredRedirectUri";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["invalidAuthorizationCode"] = 2] = "invalidAuthorizationCode";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["invalidCodeVerifier"] = 3] = "invalidCodeVerifier";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["inexistingUser"] = 4] = "inexistingUser";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["invalidScopes"] = 5] = "invalidScopes";
  AuthorizationCodeExchangeErrors[AuthorizationCodeExchangeErrors["inexistingOrganisation"] = 6] = "inexistingOrganisation";
})(AuthorizationCodeExchangeErrors || (AuthorizationCodeExchangeErrors = {}));

var RefreshAccessTokenErrors;

(function (RefreshAccessTokenErrors) {
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inexistingUserSession"] = 0] = "inexistingUserSession";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inexistingOAuthClient"] = 1] = "inexistingOAuthClient";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["invalidRefreshToken"] = 2] = "invalidRefreshToken";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["expiredRefreshToken"] = 3] = "expiredRefreshToken";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inexistingUser"] = 4] = "inexistingUser";
  RefreshAccessTokenErrors[RefreshAccessTokenErrors["inexistingOrganisation"] = 5] = "inexistingOrganisation";
})(RefreshAccessTokenErrors || (RefreshAccessTokenErrors = {}));

var CompleteAuthenticationProcessErrors;

(function (CompleteAuthenticationProcessErrors) {
  CompleteAuthenticationProcessErrors[CompleteAuthenticationProcessErrors["emptyState"] = 0] = "emptyState";
  CompleteAuthenticationProcessErrors[CompleteAuthenticationProcessErrors["inexistingAuthorizationInfos"] = 1] = "inexistingAuthorizationInfos";
  CompleteAuthenticationProcessErrors[CompleteAuthenticationProcessErrors["invalidState"] = 2] = "invalidState";
  CompleteAuthenticationProcessErrors[CompleteAuthenticationProcessErrors["inexistingAccessToken"] = 3] = "inexistingAccessToken";
})(CompleteAuthenticationProcessErrors || (CompleteAuthenticationProcessErrors = {}));

var applicationPorts = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get AuthenticateErrors () { return AuthenticateErrors; },
	get AuthorizationCodeExchangeErrors () { return AuthorizationCodeExchangeErrors; },
	get AuthorizeErrors () { return AuthorizeErrors; },
	get CompleteAuthenticationProcessErrors () { return CompleteAuthenticationProcessErrors; },
	get GetOneAccessTokenInfosErrors () { return GetOneAccessTokenInfosErrors; },
	get RefreshAccessTokenErrors () { return RefreshAccessTokenErrors; }
});

var global$1 = global$J;
var isRegExp = isRegexp;

var TypeError$1 = global$1.TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError$1("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol = wellKnownSymbol$j;

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $ = _export;
var uncurryThis = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$6;
var toString = toString$6;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const isRedirectUriValid = (registeredRedirectUris, redirectUri) => {
  return registeredRedirectUris.includes(redirectUri);
};

const authorize = getOneOauthClientById => async (oauthClientId, redirectUri) => {
  const oauthClient = await getOneOauthClientById(oauthClientId);

  if (oauthClient === null) {
    return AuthorizeErrors.inexistingOAuthClient;
  }

  if (!isRedirectUriValid(oauthClient.redirectUris, redirectUri)) {
    return AuthorizeErrors.unregisteredRedirectUri;
  }
};

const authenticate = (getOneOauthClientById, getOneUserByEmail, comparePassword, encodeAuthorizationCode) => async (oauthClientId, redirectUri, codeChallenge, state, email, password) => {
  const oauthClient = await getOneOauthClientById(oauthClientId);

  if (oauthClient === null) {
    return AuthenticateErrors.inexistingOAuthClient;
  }

  if (!isRedirectUriValid(oauthClient.redirectUris, redirectUri)) {
    return AuthenticateErrors.unregisteredRedirectUri;
  }

  const user = await getOneUserByEmail(email.toLowerCase());

  if (user === null) {
    return AuthenticateErrors.inexistingUser;
  }

  const validPassword = await comparePassword(password, user.passwordHash);

  if (!validPassword) {
    return AuthenticateErrors.invalidPassword;
  }

  const code = encodeAuthorizationCode(oauthClient.id, redirectUri, codeChallenge, user.id);
  return {
    code,
    state
  };
};

const authorizationCodeExchange = (getOneOauthClientById, decodeAuthorizationCode, validateCodeVerifier, getOneUserById, validateScopes, getOneOrganisationById, createOneAccessTokenResponse, saveOneUserSession, issuer) => async (oAuthClientId, redirectUri, authorisationCode, codeVerifier, scopes, nonce) => {
  const oAuthClient = await getOneOauthClientById(oAuthClientId);

  if (oAuthClient === null) {
    return AuthorizationCodeExchangeErrors.inexistingOAuthClient;
  }

  if (!isRedirectUriValid(oAuthClient.redirectUris, redirectUri)) {
    return AuthorizationCodeExchangeErrors.unregisteredRedirectUri;
  }

  const authorizationCodeContent = decodeAuthorizationCode(authorisationCode);

  if (authorizationCodeContent === null) {
    return AuthorizationCodeExchangeErrors.invalidAuthorizationCode;
  }

  const isCodeVerifierValid = validateCodeVerifier(codeVerifier, authorizationCodeContent.codeChallenge);

  if (isCodeVerifierValid === false) {
    return AuthorizationCodeExchangeErrors.invalidCodeVerifier;
  }

  const user = await getOneUserById(authorizationCodeContent.userId);

  if (user === null) {
    return AuthorizationCodeExchangeErrors.inexistingUser;
  }

  const scopesValidationResult = validateScopes(scopes);

  if (genericUtils.isDomainError(scopesValidationResult, ValidateScopesErrors)) {
    return AuthorizationCodeExchangeErrors.invalidScopes;
  }

  const organisation = await getOneOrganisationById(oAuthClient.organisationId);

  if (organisation === null) {
    return AuthorizationCodeExchangeErrors.inexistingOrganisation;
  }

  const accessTokenResponse = createOneAccessTokenResponse(issuer, nonce, scopes, user, oAuthClientId, organisation.url, oAuthClient.secret);
  const userSession = {
    oAuthClientId,
    refreshToken: accessTokenResponse.refreshToken,
    userId: user.id
  };
  await saveOneUserSession(userSession);
  return accessTokenResponse;
};

const refreshAccessToken = (getOneUserSessionByRefreshToken, getOneOauthClientById, decodeRefreshToken, getOneUserById, getOneOrganisationById, createOneRefreshTokenResponse, issuer) => async refreshToken => {
  const userSession = await getOneUserSessionByRefreshToken(refreshToken);

  if (userSession === null) {
    return RefreshAccessTokenErrors.inexistingUserSession;
  }

  const oAuthClient = await getOneOauthClientById(userSession.oAuthClientId);

  if (oAuthClient === null) {
    return RefreshAccessTokenErrors.inexistingOAuthClient;
  }

  const decodedRefreshToken = decodeRefreshToken(refreshToken, oAuthClient.secret);

  if (decodedRefreshToken === null) {
    return RefreshAccessTokenErrors.invalidRefreshToken;
  }

  const actualTime = Date.now() / genericUtils.TIME.MILLISECONDS_IN_A_SECOND;

  if (decodedRefreshToken.exp < actualTime) {
    return RefreshAccessTokenErrors.expiredRefreshToken;
  }

  const user = await getOneUserById(userSession.userId);

  if (!user) {
    return RefreshAccessTokenErrors.inexistingUser;
  }

  const organisation = await getOneOrganisationById(oAuthClient.organisationId);

  if (!organisation) {
    return RefreshAccessTokenErrors.inexistingOrganisation;
  }

  const refreshTokenResponse = createOneRefreshTokenResponse(issuer, decodedRefreshToken.nonce, decodedRefreshToken.scope.split(' '), user, userSession.oAuthClientId, organisation.url, oAuthClient.secret);
  return refreshTokenResponse;
};

const revokeUserSession = deleteOneUserSessionByRefreshToken => async refreshToken => {
  await deleteOneUserSessionByRefreshToken(refreshToken);
};

const getOneAccessTokenInfos = (decodeAccessToken, getOneOauthClientById, getOneOrganisationById, verifyAccessToken, getOneUserById) => async accessToken => {
  const accessTokenInfos = decodeAccessToken(accessToken);

  if (accessTokenInfos === null) {
    return GetOneAccessTokenInfosErrors.invalidAccessToken;
  }

  const oAuthClient = await getOneOauthClientById(accessTokenInfos.oAuthClientId);

  if (oAuthClient === null) {
    return GetOneAccessTokenInfosErrors.inexistingOAuthClient;
  }

  const organisation = await getOneOrganisationById(oAuthClient.organisationId);

  if (organisation === null) {
    return GetOneAccessTokenInfosErrors.inexistingOrganisation;
  }

  const isAccessTokenValid = verifyAccessToken(accessToken, oAuthClient.secret, organisation.url);

  if (isAccessTokenValid === false) {
    return GetOneAccessTokenInfosErrors.invalidAccessToken;
  }

  const user = await getOneUserById(accessTokenInfos.userId);

  if (user === null) {
    return GetOneAccessTokenInfosErrors.inexistingUser;
  }

  return accessTokenInfos;
};

const createAuthorizationInfos = (authorizationInfosFactory, saveOneAuthorizationInfos) => async (oAuthClientId, redirectUri, askedUrl) => {
  const authorizationInfos = authorizationInfosFactory(oAuthClientId, redirectUri, askedUrl);
  await saveOneAuthorizationInfos(authorizationInfos);
  return authorizationInfos;
};

const completeAuthenticationProcess = (getOneAuthorizationInfos, deleteOneAuthorizationInfos, exchangeAuthorizationCodeWithAccessToken, saveOneAccessTokenResponse, oauthClientId, oauthRedirectUri, scopes) => async (authorizationCode, state) => {
  if (genericUtils.isString(state) === false) {
    return CompleteAuthenticationProcessErrors.emptyState;
  }

  const authorizationsInfos = await getOneAuthorizationInfos();

  if (authorizationsInfos === null) {
    return CompleteAuthenticationProcessErrors.inexistingAuthorizationInfos;
  }

  if (authorizationsInfos.state !== state) {
    return CompleteAuthenticationProcessErrors.invalidState;
  }

  await deleteOneAuthorizationInfos();
  const accessTokenResponse = await exchangeAuthorizationCodeWithAccessToken(oauthClientId, oauthRedirectUri, authorizationCode, authorizationsInfos.codeVerifier, scopes.split(' '), genericUtils.generateRandomString());

  if (accessTokenResponse === null) {
    return CompleteAuthenticationProcessErrors.inexistingAccessToken;
  }

  await saveOneAccessTokenResponse(accessTokenResponse);
  return authorizationsInfos;
};

export { index$6 as accessTokenResponseModel, applicationPorts as appPorts, authenticate, authorizationCodeExchange, index$5 as authorizationInfosModel, index$4 as authorizationResponseModel, authorize, index$e as axiosAuthenticationService, index$a as bcryptPasswordService, completeAuthenticationProcess, index$f as cookiesAccessTokenResponseRepository, createAuthorizationInfos, entitiesSchemas$1 as entitiesSchemas, getOneAccessTokenInfos, index$9 as jwtTokenService, index$d as localstorageAuthorizationInfosRepository, index$3 as oauthModel, index$c as postgresqlOauthClientsRepository, index$b as postgresqlOrganisationsRepository, index$8 as postgresqlUserSessionsRepository, index$7 as postgresqlUsersRepository, refreshAccessToken, index$2 as refreshTokenResponseModel, revokeUserSession, index$1 as scopesValidationService, index as services };
